import type { UIStringsOverride } from "../i18n-ui.ts";

/** Persian (fa) UI strings. */
export const fa: UIStringsOverride = {
  actions: {
    addToCursor: "افزودن به Cursor",
    addToVscode: "افزودن به VS Code",
    askAI: "از هوش مصنوعی درباره این صفحه بپرسید",
    connectMcp: "اتصال به MCP",
    copied: "کپی شد!",
    copyClaudeCode: "کپی دستور Claude Code",
    copyCode: "کپی کد",
    copyCodex: "کپی دستور Codex",
    copyMarkdown: "کپی به‌صورت Markdown",
    copyServerUrl: "کپی نشانی سرور",
    edit: "ویرایش در GitHub",
    export: "برون‌بری",
    exportEpub: "برون‌بری به EPUB",
    exportPdf: "برون‌بری به PDF",
    generating: "در حال تولید…",
    openIn: "باز کردن در {name}",
    openInChat: "باز کردن در گفتگو",
    scrollToTop: "بازگشت به بالا",
  },
  ask: {
    ai: "هوش مصنوعی",
    clear: "پاک کردن گفتگو",
    close: "بستن",
    copy: "کپی گفتگو",
    empty: "سؤالی درباره مستندات بپرسید.",
    error: "متأسفیم، مشکلی پیش آمد.",
    label: "یک سؤال بپرسید",
    placeholder: "یک سؤال بپرسید…",
    send: "ارسال",
    tip: "نکته: باز و بسته کردن گفتگو با",
    title: "از هوش مصنوعی بپرسید",
    you: "شما",
  },
  banner: { dismiss: "بستن اطلاعیه" },
  changelog: {
    description: "به‌روزرسانی‌های محصول و یادداشت‌های انتشار.",
    showReleases: "نمایش انتشارهای {version}",
    title: "گزارش تغییرات",
  },
  content: { diagramError: "نمایش این نمودار ممکن نشد." },
  feedback: {
    no: "خیر",
    question: "آیا این صفحه مفید بود؟",
    thanks: "از بازخورد شما سپاسگزاریم!",
    yes: "بله",
  },
  languageSwitcher: { label: "زبان", untranslated: "ترجمه‌نشده" },
  nav: {
    back: "بازگشت",
    breadcrumb: "مسیر ناوبری",
    closeNavigation: "بستن ناوبری",
    deprecated: "منسوخ",
    featured: "ویژه",
    githubRepository: "مخزن GitHub",
    navigation: "ناوبری",
    primary: "اصلی",
    sections: "بخش‌ها",
    toggleNavigation: "تغییر وضعیت ناوبری",
    toggleTheme: "تغییر پوسته رنگی",
  },
  notFound: {
    description: "صفحه‌ای که به دنبال آن هستید پیدا نشد.",
    home: "بازگشت به صفحه اصلی",
    title: "صفحه پیدا نشد",
  },
  page: {
    lastUpdated: "آخرین به‌روزرسانی",
    next: "بعدی",
    pagination: "صفحه‌بندی",
    previous: "قبلی",
    skipToContent: "پرش به محتوا",
  },
  search: {
    all: "همه",
    allLanguages: "همه زبان‌ها",
    askAi: "از هوش مصنوعی بپرسید",
    askAiHint: "پاسخی فوری از هوش مصنوعی دریافت کنید",
    button: "جستجو",
    devOnly: "جستجو در نسخه تولید در دسترس است.",
    error: "مشکلی پیش آمد. لطفاً دوباره تلاش کنید.",
    label: "جستجو در مستندات",
    navigate: "پیمایش",
    noResults: "نتیجه‌ای یافت نشد.",
    open: "باز کردن",
    placeholder: "جستجو در مستندات…",
    popular: "محبوب",
    preview: "پیش‌نمایش",
    results: "نتایج",
  },
  toc: { title: "در این صفحه" },
};
